import { CLOUDINARY_BASE } from "./cloudinary"

/**
 * Fotos de las fichas servidas por Cloudinary («fetch»): la foto sigue en
 * Supabase y Cloudinary la descarga, la reduce al ancho pedido y la entrega en
 * AVIF/WebP. Es lo mismo que hace el CRM (`src/lib/images/cloudinary-image.ts`).
 *
 * Antes la web servía el JPG tal cual se subió —hasta 2.560 px y 1,5 MB— en la
 * galería, las miniaturas y el visor, y la ficha descargaba TODAS las fotos a
 * ese tamaño antes de enseñar nada. Medido con P6360: 1.172 KB el original,
 * 164 KB a 1.600 px y 17 KB a 400 px.
 *
 * Solo se envuelven los orígenes que la cuenta de Cloudinary tiene permitidos;
 * cualquier otro responde 401 y saldría la foto rota, así que se deja tal cual.
 */
const ORIGENES_PERMITIDOS = [".supabase.co/storage/", "cdn.witei.com"]

export function fotoDeFicha(url: string, ancho: number, formato: "auto" | "jpg" = "auto"): string {
  if (!url || url.includes("res.cloudinary.com") || !ORIGENES_PERMITIDOS.some((origen) => url.includes(origen))) {
    return url
  }
  return `${CLOUDINARY_BASE}/image/fetch/f_${formato},q_auto,w_${ancho},c_limit/${encodeURIComponent(url)}`
}

/**
 * Qué pedir cuando una foto servida por Cloudinary no carga, o null si ya no
 * queda nada que probar.
 *
 * Cloudinary a veces no consigue descargar la foto de Supabase a tiempo y
 * guarda el error en su caché para esa URL exacta (pasó en el CRM con P6360 en
 * Safari). Primero se pide la misma foto en JPEG, que es otra URL y otra
 * entrada de caché; si también falla, la original de Supabase.
 */
export function siguienteIntento(url: string): string | null {
  const coincidencia = url.match(/\/image\/fetch\/[^/]+\/(https?%3A%2F%2F.+)$/)
  if (!coincidencia) return null
  return url.includes("/f_auto,") ? url.replace("/f_auto,", "/f_jpg,") : decodeURIComponent(coincidencia[1])
}
